module.exports = __webpack_public_path__ + "img/60.e32d7763.jpg";